import { render, staticRenderFns } from "./OrganizationsCreate.vue?vue&type=template&id=52627a0e"
import script from "./OrganizationsCreate.vue?vue&type=script&lang=js"
export * from "./OrganizationsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports